/**
 * 
 * key
 * 
 */


const key = 'cG9zdENoYW5nZXNJblByb2dyZXNz'

export default key 